export default "__VITE_ASSET__CegXLjFB__"